import { SVGProps } from "react";

const PasswordEyeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    className="password_icon"
    cursor="pointer"
    {...props}
  >
    <path
      fill="#979797"
      fillRule="evenodd"
      d="M2.927 10a7.504 7.504 0 0 0 14.146 0 7.504 7.504 0 0 0-14.146 0Zm-1.674-.25a9.17 9.17 0 0 1 17.494.001.834.834 0 0 1 0 .5 9.17 9.17 0 0 1-17.494 0 .833.833 0 0 1 0-.5ZM10 8.335a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333Zm-3.334 1.667a3.333 3.333 0 1 1 6.667 0 3.333 3.333 0 0 1-6.667 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default PasswordEyeIcon;
